import React, { useState, useEffect, useRef } from "react";
import { Table, Button, Form, Spinner } from "react-bootstrap";
import API_BASE_URL from "../../config";
import ExportExcel from "../../utility/ExportCSV";
import enableTableSearch from "../../utility/tableSearch";
import { authFetch } from "../../utility/AuthFetch";

function GradeTable({ onEdit, reload }) {
  const [entries, setEntries] = useState([]);
  const inputRef = useRef();
  const tableRef = useRef();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEntries = async () => {
      try {
        const response = await authFetch(`${API_BASE_URL}/api/grade`);
        const result = await response.json();
        setEntries(result.grades || []);
      } catch (error) {
        console.error("Error fetching entries:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEntries();
  }, [reload]);

  useEffect(() => {
    const cleanup = enableTableSearch({
      inputRef,
      tableRef,
      columnIndex: 1,
      noDataText: "No grade found",
    });

    return cleanup;
  }, [loading]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <ExportExcel tableId="gradeTable" filename="grade_report.xlsx" />
        <Form.Control
          type="text"
          placeholder="Search"
          style={{ width: "200px" }}
          ref={inputRef}
        />
      </div>

      {loading ? (
        <div className="text-center py-4">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Table striped bordered hover id="gradeTable" ref={tableRef}>
          <thead>
            <tr>
              <th style={{ width: "100px" }}>Action</th>
              <th>Grade</th>
              <th>Minimum Marks</th>
              <th>Maximum Marks</th>
            </tr>
          </thead>
          <tbody>
            {entries.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center">
                  No records found
                </td>
              </tr>
            ) : (
              entries.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Button variant="warning" onClick={() => onEdit(item)}>
                      EDIT
                    </Button>
                  </td>
                  <td>{item.grade}</td>
                  <td>{item.minMarks}</td>
                  <td>{item.maxMarks}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}
    </>
  );
}

export default GradeTable;
